import React from 'react';
import classNames from "classnames";


import {MuiIconExternalProps} from "../icons/MuiIcon";


import './ContextMenuInEditorItem.css';


export interface ContextMenuInEditorItemProps {
    text: string;
    onClick: () => boolean | undefined | void;
    Icon?: React.ComponentType<MuiIconExternalProps>;
    isInNavigationFocus?: boolean;
    isActive?: boolean;
    className?: string;
    innerRef?: any;
    preserveContextMenu?: boolean;
    condition?: boolean;
}

export const ContextMenuInEditorItem = (
    {
        onClick,
        text,
        Icon,
        isInNavigationFocus,
        isActive,
        innerRef,
        className,
    }: ContextMenuInEditorItemProps
) => {
    return (
        <div
            ref={innerRef}
            className={classNames({
                'ContextMenuInEditorItem': true,
                'ContextMenuInEditorItem--isInNavigationFocus': isInNavigationFocus,
                'ContextMenuInEditorItem--isActive': isActive,
                [className!]: !!className,
            })}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            {Icon ? <Icon className={'ContextMenuInEditorItem__icon'} size={20}/> : null}
            <span
                className={'ContextMenuInEditorItem__text'}
                dangerouslySetInnerHTML={{'__html': text}}
            />
        </div>
    )
}
